import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { deleteGroups, endDeleteGroups } from '../../store/actions/people';
import { setPeopleGroupFilterIds } from '../../store/actions/query';
import { retrievePeople } from '../../store/actions/search';

import DeleteGroupsModal from 'components/modals/delete_groups_modal';

export class PeopleDeleteGroupModal extends React.Component {
  static propTypes = {
    deleteGroups: PropTypes.func.isRequired,
    deletingGroups: PropTypes.array,
    endDeleteGroups: PropTypes.func.isRequired,
    retrievePeople: PropTypes.func.isRequired,
    setPeopleGroupFilterIds: PropTypes.func.isRequired,
  }

  handleDeleteGroups = (groups) => {
    this.props.deleteGroups(groups);
    this.props.setPeopleGroupFilterIds([]);
    this.props.retrievePeople();
  }

  render() {
    return (
      <DeleteGroupsModal
        groups={this.props.deletingGroups}
        shown={this.props.deletingGroups != null}
        onCancel={this.props.endDeleteGroups}
        onDelete={this.handleDeleteGroups}
      />
    );
  }
}

const mapStateToProps = state => ({
  deletingGroups: state.people.deletingGroups
});

const mapDispatchToProps = {
  deleteGroups,
  endDeleteGroups,
  retrievePeople,
  setPeopleGroupFilterIds
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleDeleteGroupModal);
